import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// Prev / next pager with a label, shared by the Notifications page and the dashboard section.
export default function NotifPager({ page, pages, label, onPage, testId = "notifications" }) {
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-3" data-testid={`${testId}-pagination`}>
      <Button variant="outline" size="sm" className="rounded-full" disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label="Previous page" data-testid={`${testId}-prev`}><ChevronLeft className="h-4 w-4" /></Button>
      <span className="text-sm font-medium tabular-nums text-slate-600" data-testid={`${testId}-page-indicator`}>{label}</span>
      <Button variant="outline" size="sm" className="rounded-full" disabled={page >= pages} onClick={() => onPage(page + 1)} aria-label="Next page" data-testid={`${testId}-next`}><ChevronRight className="h-4 w-4" /></Button>
    </div>
  );
}
